import { FieldArray, useField } from 'formik'
import {
  BrandPlanScheduleCrosspostInput,
  VariablesOf
} from 'hooks/queries/brandKits/useCreateSchedule'
import { Text } from 'blaze-ui/Text/Text'
import dayjs from 'dayjs'
import Styles from './CampaignsField.module.scss'
import cx from 'classnames'
import { EditChannelsModal } from 'screens/Campaign/Overview/EditChannelsModal/EditChannelsModal'
import { ModalTrigger } from 'almanac-ui/Modal/ModalTrigger'
import { Pressable } from '@react-aria/interactions'
import { useModals } from 'almanac-ui/Modal'
import { FormValues } from 'screens/Campaign/Overview/EditChannelsModal/Types'
import { BrandPlanSchedulePlan } from 'types'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { Edit1 } from 'blaze-ui/icons'
import { EditScheduleModal } from 'screens/Campaign/Overview/EditScheduleModal/EditScheduleModal'
import { EditScheduleFormValues } from 'screens/Campaign/Overview/Types'
import { Channels } from './Channels'

export const CampaignsField = ({ name }: { name: string }) => {
  const { closeModal } = useModals()
  const [field] = useField<VariablesOf<BrandPlanScheduleCrosspostInput>[]>(name)

  return (
    <table className={Styles.table}>
      <thead className={Styles.head}>
      <tr>
        <th className={Styles.cell}><Text variant="label">Topic</Text></th>
        <th className={Styles.cell}><Text variant="label">Start & end date</Text></th>
        <th className={Styles.cell}><Text variant="label">Channels</Text></th>
      </tr>
      </thead>
      <tbody>
      <FieldArray name={name}>
        {({ replace }) =>
          field.value.map((campaign, index) => {
            return (
              <tr key={`campaign-${index}`}>
                <th className={cx(Styles.cell, Styles.cellHeader)}>
                  <Text lineClamp={1}>{campaign.strategy?.themes?.[0]?.title}</Text>
                </th>
                <ModalTrigger
                  modal={EditScheduleModal}
                  schedule={{ ...campaign, approval_date: dayjs(campaign.start_date).subtract(campaign.days_before_review, 'day').format('YYYY-MM-DD')}}
                  options={{ newStack: true }}
                  onSubmit={(values: EditScheduleFormValues) => {
                    closeModal()
                    replace(index, { ...campaign, ...values })
                  }}
                >
                  <Pressable>
                    <td className={cx(Styles.cell, Styles.editable)}>
                      <div>
                        <Text lineClamp={1}>
                          {dayjs(campaign.start_date).format('MMM D')} - {dayjs(campaign.start_date).add(campaign.length || 1, 'weeks').format('MMM D')}
                        </Text>
                        <IconButton icon={Edit1} aria-label="Edit Channels" variant="ghost" size="sm" />
                      </div>
                    </td>
                  </Pressable>
                </ModalTrigger>
                <ModalTrigger
                  modal={EditChannelsModal}
                  campaign={campaign as Omit<Partial<BrandPlanSchedulePlan>, 'approval_date'>}
                  options={{ newStack: true }}
                  onSubmit={(values: FormValues) => {
                    closeModal()
                    replace(index, { ...campaign, ...values })
                  }}
                >
                  <Pressable>
                    <td className={cx(Styles.cell, Styles.editable)}>
                      <div>
                        <Channels campaign={campaign} />
                        <IconButton icon={Edit1} aria-label="Edit Channels" variant="ghost" size="sm" />
                      </div>
                    </td>
                  </Pressable>
                </ModalTrigger>
              </tr>
            )
          })
        }
      </FieldArray>
      </tbody>
    </table>
  )

}
